'use client'

import type { CompanySwitcherSlideInProps } from '@maestro/commerce-blocks/components/company-switcher/company-switcher.types'

import { useTranslations } from 'next-intl'

import { CompanySwitcherItem } from '@maestro/commerce-blocks/components/company-switcher'
import { useCompanySwitcherSlideIn } from '@maestro/commerce-blocks/components/company-switcher/batons/use-company-switcher-slide-in'
import {
  SwitcherEmptyState,
  SwitcherList,
  SwitcherSlideIn,
} from '@maestro/commerce-blocks/components/switcher'

export default function CompanySwitcherSlideIn(
  props: CompanySwitcherSlideInProps
) {
  const { onClose } = props
  const t = useTranslations('commerce-blocks.company-switcher')

  const {
    companies,
    areCompaniesLoading,
    isSearchEnabled,
    searchCompanies,
    activeCompanyId,
    selectingId,
    selectCompany,
  } = useCompanySwitcherSlideIn(onClose)

  const search = isSearchEnabled
    ? {
        legend: t('search-companies'),
        placeholder: t('search-placeholder'),
        onChange: searchCompanies,
      }
    : undefined

  return (
    <SwitcherSlideIn
      search={search}
      isLoading={areCompaniesLoading}
      isEmpty={!companies.length}
      emptyState={
        <SwitcherEmptyState
          title={t('empty-title')}
          description={t('empty-description')}
        />
      }
      onClose={onClose}
    >
      <SwitcherList>
        {companies.map((company) => (
          <CompanySwitcherItem
            key={`company-${company.id}`}
            company={company}
            isSelected={company.id === activeCompanyId}
            isPending={company.id === selectingId}
            isDisabled={!!selectingId}
            onSelect={() => selectCompany(company)}
          />
        ))}
      </SwitcherList>
    </SwitcherSlideIn>
  )
}
